<template>
    <v-app pb-3>
        <v-content class="osago-pre-calc-steps">
            <StepZero
                v-if="step===0"
                :showPartners="showPartners"
                class="step-0"
                style="max-width: 1240px; margin: 0 auto;"
                @next="next"
                @changePreloading="changePreloading"
                @requestsByNumber="requestsByNumber"
                @startPreloading="startPreloading"
            ></StepZero>
            <v-container style="max-width: 1240px;"
                        class="py-4 header-part"
                        v-if="step>0"
                >

                <v-layout class="header-part-title" v-if="step != 5">
                    <v-flex xs12 py-2>
                        <h1>Расчёт стоимости ОСАГО</h1>
                        <span style="font-size: 20px; margin: 5px 0;">в 15 страховых компаниях</span>
                    </v-flex>
                </v-layout>


                <v-layout v-if="step > 0 && step < 5" class="step-navigation">
                    <v-flex xs4 md4 pt-2 class="step" :class="[step === 1 ? 'current-step' : '', step > 1 ? 'clickable' : '']">
                        <div class="line"></div>
                        <div class="number" @click="toStep(1)">1</div>
                        <div class="name" @click="toStep(1)">Автомобиль</div>
                    </v-flex>
                    <v-flex xs4 md3 pt-2 class="step" :class="[step === 2 ? 'current-step' : '', step > 2 ? 'clickable' : '']">
                        <div class="line"></div>
                        <div class="number" @click="toStep(2)">2</div>
                        <div class="name" @click="toStep(2)">Водители</div>
                    </v-flex>
                    <v-flex xs4 md3 pt-2 class="step" :class="[step === 3 ? 'current-step' : '', step > 3 ? 'clickable' : '']">
                        <div class="line"></div>
                        <div class="number" @click="toStep(3)">3</div>
                        <div class="name" @click="toStep(3)">Страхователь</div>
                    </v-flex>
                    <v-flex xs4 md3 pt-2 class="step" :class="[step === 4 ? 'current-step' : '', step > 4 ? 'clickable' : '']">
                        <div class="number" @click="toStep(4)">4</div>
                        <div class="name" @click="toStep(4)">Расчёт</div>
                    </v-flex>
                </v-layout>

                <v-layout v-if="progressPercent > 0 && step < 5">
                    <v-flex class="scale-percent">
                        Уже заполнено {{ progressPercent }}% данных.
                    </v-flex>
                </v-layout>

            </v-container>

            <v-form ref="form" v-model="valid" v-if="step>0">


                <v-container v-if="step===2"
                             style="max-width: 1240px"
                             class="py-0"
                >
                    <v-layout>
                        <v-flex xs12 pt-0 pb-2>
                            <h2>Водители</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex xs12 py-0>
                            <v-checkbox
                                v-model="unlimitedDrivers"
                                label="Количество допущеных водителей не ограничено"
                                @change="unlimitedDriversChange(unlimitedDrivers)"
                                class="mt-0"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container
                        style="max-width: 1240px" class="py-0"
                        v-if="step===2 && !unlimitedDrivers"
                        v-for="(driver, key) in drivers" :key="'driver' + driver.n"
                >
                    <v-layout>
                        <v-flex xs12 pt-2 pb-3>
                            <h3>Водитель {{ driver.n }}</h3>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="driver.fio.old"
                                :label="'Менялась фамилия после ' + yearBefore"
                                @change="oldSurnameToggle(driver)"
                            />
                            <osago-name
                                v-model="driver.fio.surname"
                                label="Фамилия"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0
                                v-if="driver.fio.old"
                        >
                            <osago-name
                                v-model="driver.fio.oldSurname"
                                label="Старая фамилия"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="driver.fio.name"
                                label="Имя"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="driver.fio.patronymic"
                                label="Отчество"
                                optional="true"
                                :noField.sync="driver.fio.noPatronymic"
                                genitiveLabel="отчества"
                                @change="setGender(driver)"
                            />
                            <osago-gender
                                v-if="driver.fio.noPatronymic"
                                v-model="driver.gender"
                                label="Пол"
                                :noField.sync="driver.gender"
                            />
                        </v-flex>

                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="driver.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateDriversMinimal"
                                @change="driver.firstDriverLicense = setDriverBirthday(driver)"
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 sm6 md3 lg3 py-0>
                            <v-checkbox
                                style="margin-top: 0; height: 25px;"
                                v-model="driver.license.old"
                                :label="'Менял права после ' + yearBefore"
                                @change="oldLicenseToggle(driver)"
                            />
                            <v-text-field
                                v-model="driver.license.seriesNumber"
                                :label="(driver.license.old ? 'Новые права' : 'Права') + ': серия и номер'"
                                :rules="[rules.required,rules.license]"
                                @paste="removeSpacesOnPaste($event, driver.license.seriesNumber)"
                                mask="##SS ######"
                                return-masked-value
                                validate-on-blur
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg3 py-0 style="align-self: flex-end"
                                v-if="driver.license.old"
                        >
                            <v-text-field
                                v-model="driver.license.oldSeriesNumber"
                                label="Старые права: серия и номер"
                                :rules="[rules.required,rules.license,noEquilSeriesNumber]"
                                @paste="removeSpacesOnPaste($event, driver.license.oldSeriesNumber)"
                                mask="##SS ######"
                                return-masked-value
                                validate-on-blur
                                @input="inputOldLicenseNumber($event, driver)"
                            />
                        </v-flex>
                        <v-flex xs10 sm5 md3 lg3 py-0 style="align-self: flex-end">
                            <v-checkbox
                                style="margin-top: 0px; height: 25px;"
                                v-model="driver.license.rememberYearOnly"
                                label="Помню только год"
                            />
                            <v-autocomplete
                                v-if="driver.license.rememberYearOnly"
                                :items="getFirstLicenseYears(driver.dateFirstLicense, dateToday)"
                                :rules="[rules.required]"
                                :value="driver.license.date ? +driver.license.date.split('-')[0] : null"
                                @change="driver.license.date = $event + '-12-31';"
                                label="Год выдачи первых прав"
                            />
                            <osago-date
                                v-if="!driver.license.rememberYearOnly"
                                v-model="driver.license.date"
                                label="Дата выдачи первых прав"
                                :isFirstLicense="true"
                                :min="driver.firstDriverLicense"
                                :max="dateToday"
                                :restrictJan1="true"
                                @blur="driver.firstDriverLicense = setDriverBirthday(driver)"
                                :isHideMobile="true"
                            />
                        </v-flex>
                        <v-flex xs1 pt-0 style="max-width: 40px; align-self: flex-end">
                            <p class="pt-3 pb-2">
                                <img class="tip-icon pt-3" src="/svg/q.svg" alt=""
                                     data-tippy-animateFill="false"
                                     data-tippy-animation="scale"
                                     data-tippy-content="Дата выдачи первых прав указана на обратной стороне прав."
                                />
                            </p>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex shrink pt-0
                                v-if="drivers.length < 4 && driver.n === drivers.length"
                                class="driverControls"
                        >
                            <a @click="addDriver(driver)">
                                <img src="/svg/plus.svg" style="width: 21px; height:21px; vertical-align: -5px;"/>
                                Добавить водителя
                            </a>
                        </v-flex>
                        <v-flex grow pt-0
                                v-if="drivers.length > 1"
                                class="driverControls"
                        >
                            <a @click="removeDriver(driver)">
                                <img src="/svg/minus.svg" style="width: 21px; height:21px; vertical-align: -5px;"/>
                                Убрать водителя
                            </a>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container v-if="step===1"
                        style="max-width: 1240px" py-0
                >
                    <osago-transport
                        :short="false"
                        v-model="transport"
                        :dateToday="dateToday"
                        :showLicensePlateInfoLoader="false"
                        :numberInfoLoading="numberInfoLoading"
                        :rsaInfoLoading="rsaInfoLoading"
                        :gibddInfoLoading="gibddInfoLoading"
                        :dateOldPolis="dateOldPolis"
                        :hideCarDocAndToDoc="true"
                        @clearTransport="clearTransport"
                        :vinHide="true"
                    />

                    <osago-insurance-conditions
                        :isEgarant="isEgarant"
                        :usagePurposes="usagePurposes"
                        :usagePurpose="usagePurpose"
                        :dateStart="dateStart"
                        :dateMin="dateToday"
                        :dateStartMax="dateStartMax"
                        :rules="rules"
                        :term="term"
                        :dateOldPolis="dateOldPolis"
                        :osagoCompanyName="osagoCompanyName"
                        :rsaInfoLoading="rsaInfoLoading"
                        :alertText="alertText"
                        :alertColor="alertColor"
                        @changeInsuranceConditionsData="changeInsuranceConditionsData"
                    />

                    <osago-user
                        :titleText = "osagoUserTitle"
                        :phoneInputText = "phoneInputText"
                        :attentionText = "attentionText"
                        :b2c = "b2c"
                        :short = "true"
                        v-model="user"
                    />
                </v-container>

                <v-container
                    style="max-width: 1240px" py-0
                    v-if="step == 3"
                >
                    <v-layout>
                        <v-flex pb-4 pt-5>
                            <h2>Собственник и страхователь</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout>
                        <v-flex md4 class="clear-fields-link-block">
                            <a
                                class="policy ml-2"
                                style="text-decoration: underline"
                                @click="clearFields"
                            >
                                Очистить поля
                            </a>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="owner.fio.surname"
                                label="Фамилия"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="owner.fio.name"
                                label="Имя"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="owner.fio.patronymic"
                                label="Отчество"
                                optional="true"
                                :noField.sync="owner.fio.noPatronymic"
                                genitiveLabel="отчества"
                                @change="setGender(owner)"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="owner.birthday"
                                label="Дата рождения"
                                isBirthday="true"
                                :max="dateDriversMinimal"
                                @change="owner.dateDriverPassport = getDateDriverPassport(owner);
                                    owner.dateFirstLicense = getDateFirstLicense(owner)"
                                :isHideMobile="true"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-1>
                        <v-flex xs12 sm6 md3 lg2 py-0>
                            <h4 style="display: inline">Паспорт</h4>

                            <v-text-field
                                v-model="owner.passport.seriesNumber"
                                :rules="[rules.required, rules.passport]"
                                @blur="setPassportIssuedBy(owner)"
                                label="Серия и номер"
                                mask="#### ######"
                                return-masked-value
                                validation-on-blur
                                required
                                class="pt-1"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <osago-date
                                label="Дата выдачи"
                                v-model="owner.passport.date"
                                :passportAgeCheck="owner.dateDriverPassport"
                                :min="owner.dateDriverPassport"
                                :max="dateToday"
                                :isHideMobile="true"
                            />
                        </v-flex>

                        <v-flex xs12 md12 lg8 py-0>
                            <h4 style="display: inline; margin: 5px 0 -5px;">Адрес регистрации</h4>
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                data-tippy-animateFill="false"
                                data-tippy-animation="scale"
                                data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />

                            <osago-address-dadata
                                :model="owner.address"
                                :checkHouseFiasLevel="true"
                                :goToElement="false"
                                class="pt-1"
                            />
                        </v-flex>
                    </v-layout>


                    <osago-user
                        :titleText = "'E-mail для получения полиса'"
                        :phoneInputText = "phoneInputText"
                        :attentionText = "attentionText"
                        :b2c = "b2c"
                        :hidePhone = "true"
                        v-model="user"
                    />

                </v-container>

                <v-container py-0 style="max-width: 1240px;"
                             v-if="step == 4">

                    <osago-cardoc
                        v-model="transport.carDoc"
                        :yearIssue="transport.yearIssue"
                        :dateToday="dateToday"
                        :showCarDocLoader="false"
                        :disabled="numberInfoLoading || gibddInfoLoading"
                        :numberInfoLoading="numberInfoLoading"
                        :gibddInfoLoading="gibddInfoLoading"
                    />
                </v-container>

                <v-container py-0 style="max-width: 1240px;"
                             v-if="step == 5"
                >
                    <osago-long-form
                        :params = params
                        :needRequestInsurance = needRequestInsurance
                        @savePreparedData = "savePreparedData"
                        @updateFromStep3 = "updateFromStep3"
                        @setResultPreloading = "setResultPreloading"
                        @startPreloading = "startPreloading"
                    />
                </v-container>

                <v-container py-0 style="max-width: 1240px;"
                             v-if="step <= 4"
                >
                    <v-layout pt-4 row wrap>
                        <v-flex class="bottom-block">
                            <v-flex class="buttons-block">
                                <v-btn @click="back" v-if="step >= 1"
                                    class="button prev-button block"
                                >
                                    Назад
                                </v-btn>
                                <v-btn @click="next" v-if="step < 4"
                                    class="button next-button block"
                                    :loading="this.wait"
                                >
                                    Продолжить
                                </v-btn>
                                <v-btn @click="validate" v-if="step == 4"
                                    class="button next-button block"
                                    :loading="this.wait"
                                >
                                    Рассчитать
                                </v-btn>
                            </v-flex>
                            <v-flex v-if="step===1" class="terms-and-conditions">
                                <v-checkbox
                                    v-model="privacyPolicyApproved"
                                    :rules="[rules.approvePrivacyPolicy]"
                                    class="mt-0"
                                >
                                    <template v-slot:label>
                                        <div class="policy-wrapper">
                                            Отправляя анкету, соглашаюсь
                                            <br>с <a class="policy" target="_blank" href="https://getpolis.ru/osago_policy">политикой
                                            обработки персональных данных</a>
                                            <br>и даю
                                                <a class="policy" target="_blank" href="https://getpolis.ru/soglasie_pdn">
                                                    Согласие на обработку персональных данных
                                                </a>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-container>

            </v-form>
        </v-content>

        <transition name="fade">
            <osago-preview
                v-if="preview.show"
                :preparedFormData="preparedFormData"
                :previewUsagePurpose="usagePurposes[preparedFormData.usagePurpose]"
                :return="this.toStep4"
                :submit="this.submitPreview"
                :b2b="b2b"
                :loading="this.wait"
            />
        </transition>

        <osago-preloader
            v-show="preloading"
            :preloading="preloading"
            :step="step"
            :resultPreloading="resultPreloading"
            :slideInterval="4000"
            @stopPreloading="stopPreloading"
        />
    </v-app>
</template>

<script>
    import _ from 'lodash';
    import ymMixin from '../mixins/ym';
    import helperMixin from '../mixins/helper';
    import moment from "moment";
    import StepZero from './steps/StepZero'

    export default {
        props: ['params', 'userdata', 'showPartners', 'isWidget'],
        mixins: [ymMixin, helperMixin],
        components: {
            StepZero
        },

        data: () => ({
            progressPercent: 0,
            term: 12,
            usagePurposes: {},
            usagePurpose: null,
            privacyPolicyApproved: false,
            unlimitedDrivers: false,
            prevPolicyNumber: '',
            stepFlags: {},
            osagoUserTitle: "Телефон для сохранения расчета",
            phoneInputText: "Телефон, будет логином для входа в личный кабинет",
            attentionText: "По номеру телефона мы сохраним всё что вы заполнили. Вы сможете продолжить, когда Вам будет удобно",
            resultPreloading: false,
            yearBefore: moment().subtract(1, 'years').format('DD.MM.YYYY'),
            loadedFromStorage: false,
            gosNumber: null,
            drivers: [],
            b2c: true,
            b2b: false,
            dateOldPolis: null,
            osagoCompanyName: null,
            driversDefault: null,
            ownerDefault: null,
            insurerDefault: null,
            owner: {
                fio: {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false,
                    old: false,
                    oldSurname: null
                },
                gender: null,
                birthday: null,
                passport: {
                    seriesNumber: null,
                    date: null,
                    issuedBy: null
                },
                address: {
                    search: null
                }
            },
            ownerIsSet: false,
            insurer: {
                fio: {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false,
                    old: false,
                    oldSurname: null
                },
                gender: null,
                birthday: null,
                passport: {
                    seriesNumber: null,
                    date: null,
                    issuedBy: null
                },
                address: {
                    search: null,
                }
            },
            transport: {
                category: 'B',
                mark: null,
                model: null,
                writtenMark: null,
                writtenModel: null,
                idType: 'vin',
                vin: null,
                vinHidden: null,
                bodyNumber: null,
                chassisNumber: null,
                power: null,
                licensePlate: null,
                noLicensePlate: false,
                yearIssue: null,
                carCode: null,
                carDoc: {
                    type: 'pts',
                    seriesNumber: null,
                    date: null,
                },
                toDoc: {
                    type: 'dcard',
                    seriesNumber: null,
                    endDate: null
                }
            },
            toDocDefault: {
                type: 'dcard',
                seriesNumber: null,
                endDate: null
            },
            info: {},
            user: {
                phone: '7',
                email: null
            },

            uuid: null,
            valid: true,
            step: 0,

            dateToday: '',
            dateTomorrow: '',
            dateStartMax: '',
            dateFrom: '',
            dateStart: '',
            dateDriversMinimal: '',

            preparedFormData: {},

            preloading: false,
            wait: false,

            getpolisPhone: null,

            coeffs: null,

            preview: {
                show: false,
            },

            isEgarant: false,

            autoSaveInterval: null,

            needRequestInsurance: false,

            numberInfoLoading: false,
            rsaInfoLoading: false,
            gibddInfoLoading: false,

            noEquilSeriesNumber: true,

            autoActiveUpdateTimestamp: 60000,

            widgetId: null,
            widgetUuid: null,
            alertText: null,
            alertColor: null,

            rules: {
                required: v => !!v || 'Обязательное поле',
                useTarget: v => v || 'Необходимо подтвердить цель использования авто',
                license: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || 'Неверный формат',
                approvePrivacyPolicy: v => v || 'Необходимо согласиться с политикой обработки персональных данных',
                number: v => /^[АВЕКМНОРСТУХ\d]{4,}$/.test(v) || 'Неверный формат',
                policyNumber: v => v === '' || /^[А-ЯA-Z]{3} \d{10}$/.test(v) || 'Неверный формат',
                passport: v => /^\d{4} \d{6}$/.test(v) || 'Неверный формат'
            },
        }),
        created: function () {

            this.transportDefault = _.cloneDeep(this.transport);

            this.ownerDefault = _.cloneDeep(this.owner);
            this.insurerDefault = _.cloneDeep(this.insurer);

            const params = JSON.parse(window.atob(this.params))
            if (this.uuid == null) {
                this.setUuid(params.uuid);
            }

            if (!this.checkParameterGosNumber()) {
                this.checkSessionStorage();
            }

            if (!sessionStorage.maxStep) {
                sessionStorage.maxStep = 0;
            }

            if (this.step > 1) {
                this.startPreloading();
            }

            if (params.config) {
                this.loadConfig(params.config);
            }
            if (params.usagePurposes) {
                this.usagePurposes = params.usagePurposes;
            }

            if (params.orderData) {
                if (this.drivers.length == 0) {
                    this.loadOrderData(params.orderData);
                }
            } else {
                this.addDriver();
            }
            if (params.widgetId) {
                this.widgetId = params.widgetId;
                this.widgetUuid = params.widgetUuid;
            }

            this.updatePercents();

            this.updateAutoSave();

            this.autoActiveUpdate(this.autoActiveUpdateTimestamp);
        },

        updated: function () {
            window.tippy.default('.tip-icon');
        },

        watch: {
            'transport.carDoc.type': {
                handler() {
                    if (this.transport.carDoc.type === 'srts') {
                        // при указании документа СТС ввод госномера обязателен
                        this.transport.noLicensePlate = false;
                    }
                }
            }
        },

        methods: {
            inputOldLicenseNumber(event, driver) {
                if (event == driver.license.seriesNumber) {
                    this.noEquilSeriesNumber = 'Не может совпадать с номером новых прав'
                } else {
                    this.noEquilSeriesNumber = true
                }
            },

            checkParameterGosNumber() {
                let url = new URL(window.location)
                let urlParams = new URLSearchParams(url.search.slice(1));
                if (urlParams.get("gosNumber")) {
                    this.gosNumber = urlParams.get("gosNumber")
                    if (this.gosNumber == 'none') {
                        this.setNoLicensePlate()
                        this.next()
                    } else {
                        this.startPreloading()
                        this.requestsByNumber(this.gosNumber)
                        this.next()
                    }
                    urlParams.delete("gosNumber")
                    return true
                }
                return false
            },

            clearFields() {
                this.drivers.forEach((driver) => {
                    driver.isOwner = false
                    driver.isInsurer = false
                });

                this.owner = _.cloneDeep(this.ownerDefault)
                this.insurer = _.cloneDeep(this.insurerDefault)

                this.clearPerson(this.owner)
                this.clearPerson(this.insurer)
            },

            clearTransport() {
                this.transport = _.cloneDeep(this.transportDefault);
            },

            submitPreview() {
                this.needRequestInsurance = true
                this.next()
            },

            toStep4() {
                this.needRequestInsurance = false
                this.next()
            },

            autoActiveUpdate(timeout) {
                this.updateActiveRequest()
                setInterval(() => {
                    this.updateActiveRequest()
                }, timeout)
            },

            updateActiveRequest() {
                if (this.uuid) {
                    axios.post(`/osago/calc/${this.uuid}/updateactive`)
                }
            },

            autoSaveOn(timeout) {
                let that = this;
                this.autoSaveInterval = setInterval(function () {
                    that.prepareFormData();
                    if (that.lastSavedFormData == null) {
                        that.lastSavedFormData = _.cloneDeep(that.preparedFormData);
                        return;
                    }
                    if (!_.isEqual(that.lastSavedFormData, that.preparedFormData)) {
                        that.autoUpdate(that.preparedFormData);
                        that.lastSavedFormData = _.cloneDeep(that.preparedFormData);
                    }
                }, timeout);
            },

            autoSaveOff() {
                clearInterval(this.autoSaveInterval);
            },

            changeInsuranceConditionsData(data) {
                this.dateStart = data.dateStart;
                this.term = data.term;
                this.usagePurpose = data.usagePurpose;
                this.alertText = data.alertText;
                this.alertColor = data.alertColor;
                this.dateOldPolis = data.dateOldPolis;
                this.osagoCompanyName = data.osagoCompanyName;
            },

            checkSessionStorage() {
                if (this.loadedFromStorage) {
                    return
                }
                this.loadedFromStorage = true

                if (sessionStorage.uuid && sessionStorage.uuid !== 'null') {
                    if (this.uuid != sessionStorage.uuid) {
                        return;
                    }
                    if (this.step >= 2 && this.userdata) {
                        this.uuid = sessionStorage.uuid
                        window.history.pushState(null, null, '/osago/calc/' + this.uuid +
                            (this.isWidget ? '?isWidget=1' : ''));
                    }
                }
                if (sessionStorage.step) {
                    if (sessionStorage.step > 1 && sessionStorage.uuid == 'null') {
                        this.clearProgress()
                    }
                    this.step = parseInt(sessionStorage.step)
                    this.toStep(this.step)
                }
                if (!sessionStorage.addedDriversToStep3) {
                    sessionStorage.addedDriversToStep3 = false
                }
                if (!sessionStorage.updatedOn3Step) {
                    sessionStorage.updatedOn3Step = false
                }
                if (sessionStorage.getItem('stepFlags') !== null) {
                    this.stepFlags = JSON.parse(sessionStorage.getItem('stepFlags'))
                }
                if (sessionStorage.getItem('preparedFormDataStorage') === null) {
                    return
                }
                try {
                    let data = JSON.parse(sessionStorage.getItem('preparedFormDataStorage'))
                    this.preparedFormData = data
                    if (data.transport) {
                        this.transport = data.transport
                    }
                    if (data.insurer) {
                        this.insurer = data.insurer
                    }
                    if (data.privacyPolicyApproved) {
                        this.privacyPolicyApproved = data.privacyPolicyApproved
                    }
                    if (data.term) {
                        this.term = data.term
                    }
                    if (data.prevPolicyNumber) {
                        this.prevPolicyNumber = data.prevPolicyNumber
                    }
                    if (data.user) {
                        this.user = data.user
                    }
                    if (data.dateStart) {
                        this.dateStart = data.dateStart
                    }
                    if (data.dateOldPolis) {
                        this.dateOldPolis = data.dateOldPolis
                    }
                } catch(e) {
                    console.log(e)
                }
            },

            validate() {
                if (this.$refs.form.validate()) {
                    this.reachGoal('step4_click');
                    this.prepareFormData();
                    this.preview.show = true;
                    this.$nextTick(function () {
                        $('.preview-window').css('height', $(window).height());
                    });

                    this.reachGoal('calcFinish');
                } else {
                    this.$nextTick(function () {
                        PNotify.error('Проверьте правильность выделенных полей.');
                        this.goToFirstError();
                    });
                }
            },

            goToFirstError() {
                this.$vuetify.goTo('.error--text', {
                    duration: 600,
                    offset: 150,
                    easing: 'easeInCubic',
                });
            },

            returnToEdit() {
                this.preview.show = false;
                this.reachGoal('calcDataFalse');
            },

            updateFromStep3(data) {
                this.drivers = data.drivers
            },

            startPreloading() {
                this.preloading = true
                let msDelay = 12000
                if (this.step == 5) {
                    msDelay = 27000
                }
                this.delay(msDelay)
                .then(() => {
                    if (this.preloading) {
                        this.updatePreloadersFlags()
                        this.preloading = false
                        this.resultPreloading = false
                    }
                })
            },

            updatePreloadersFlags() {
                this.stepFlags[this.step] = true
                const parsed = JSON.stringify(this.stepFlags)
                sessionStorage.setItem('stepFlags', parsed)
            },

            stopPreloading() {
                this.preloading = false
                this.resultPreloading = false
            },

            setResultPreloading() {
                this.resultPreloading = true
            },

            requestsByNumber(gosNumber) {
                this.gosNumber = gosNumber;
                this.numberInfoLoading = true;

                try {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(
                            Vue.GetpolisConstants.RECAPTCHA_SITEKEY,
                            {action: Vue.GetpolisConstants.RECAPTCHA_ACTIONS.NUMBER}
                        ).then(token => {
                            axios.post('/info/number-info-b2c', {'number': this.gosNumber, 'r': token})
                                .then(response => {
                                    this.setTransportData({data: response.data.response, gosNumber: this.gosNumber})
                                    this.loadRsaPolicyData()
                                    if (response.data.response.vin) {
                                        this.step4Requests()
                                    }
                                })
                                .catch(error => {
                                    console.log(error)
                                    this.setTransportData({data: [], gosNumber: this.gosNumber})
                                }).finally(() => {
                                    this.numberInfoLoading = false;
                            })
                        });
                    })
                } catch (e) {
                    console.log(e);
                    this.numberInfoLoading = false;
                }
            },

            step4Requests() {
                if (!this.transport.carDoc.date && !this.gibddInfoLoading && this.transport.vin) {
                    this.gibddInfoLoading = true
                    axios.get(`/info/gibdd?vin=${this.transport.vin}`)
                    .then(response => {
                        this.setPtsDate(response.data.response)
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        this.gibddInfoLoading = false
                    })
                }

            },

            setTransportData(data) {
                if (data.gosNumber) {
                    this.transport.licensePlate = data.gosNumber;
                }
                this.transport.idType = 'vin';
                if (data.data) {
                    this.info = data.data;
                    if (this.info.vin) {
                        this.$nextTick(() => {
                            this.transport.bodyNumber = '';
                            this.transport.vin = this.info.vin;
                            this.transport.vinHidden = this.hideVIN(this.info.vin);
                        });
                    } else if (this.info.body) {
                        this.transport.idType = 'bodyNumber';
                        this.$nextTick(() => {
                            this.transport.vinHidden = this.transport.vin = '';
                            this.transport.bodyNumber = this.info.body;
                        });
                    } else {
                        this.$nextTick(() => {
                            this.transport.vin = this.transport.bodyNumber = '';
                        });
                    }
                    this.transport.power = this.info.power;
                    this.transport.yearIssue = this.info.year;
                    this.transport.carDoc.type = this.info.stsType;
                    this.transport.carDoc.seriesNumber = this.info.sts;
                    if (this.info.brandDefault) {
                        this.transport.mark = this.info.brandDefault;
                    }
                    if (this.info.modelDefault) {
                        this.transport.model = this.info.modelDefault;
                    }
                    if (this.info.age && this.info.age < 4) {
                        return;
                    }

                    this.progressPercent = 55
                }
            },

            setPtsDate(data) {
                if (!data) {
                    return
                }
                if (data.ptsFrom && this.transport.carDoc.seriesNumber) {
                    this.transport.carDoc.date = data.ptsFrom
                }
                if (data.ptsNum && data.ptsType && !this.transport.carDoc.seriesNumber) {
                    this.transport.carDoc.type = data.ptsType
                    this.transport.carDoc.seriesNumber = data.ptsNum
                    this.transport.carDoc.date = data.ptsFrom
                }
            },

            hideVIN(vin) {
                return vin.substr(0, 3) + '***********' + vin.substr(-3, 3)
            },

            setDriverBirthday(driver) {
                if (driver.birthday) {
                    const [year, month, day] = driver.birthday.split('-');
                    const dateFirstLicense = `${parseInt(year) + 18}-${month}-${day}`;
                    if (driver.license && driver.license.date) {
                        if (driver.license.date > this.dateToday) {
                            driver.license.date = this.dateToday;
                        } else if (driver.license.date < dateFirstLicense) {
                            driver.license.date = dateFirstLicense;
                        }
                    }
                    return dateFirstLicense;
                }
            },

            setNoLicensePlate() {
                this.transport.noLicensePlate = true
            },

            addDriver() {
                this.drivers.push({
                    n: this.drivers.length + 1,
                    fio: {
                        surname: null,
                        name: null,
                        patronymic: null,
                        noPatronymic: false,
                        old: false,
                        oldSurname: null
                    },
                    license: {
                        seriesNumber: null,
                        date: null,
                        old: false,
                        oldSeriesNumber: null,
                        rememberYearOnly: false
                    },
                    passport: {
                        seriesNumber: null,
                        date: null,
                        issuedBy: null
                    },
                    address: {
                        search: null
                    },
                    birthday: null,
                    gender: null,
                    isOwner: false,
                    isInsurer: false,
                });
            },

            removeDriver(driver) {
                this.$delete(this.drivers, driver.n - 1)

                this.drivers = this.drivers.map(function(drv, index) {
                    drv.n = index + 1;
                    return drv;
                });
            },

            clearPerson(person) {
                this.clearFioAndBirthday(person);
                this.clearPassportAndAddress(person);
            },

            clearPassportAndAddress(person) {
                person.passport = {
                    seriesNumber: null,
                    date: null,
                    issuedBy: null
                };
                person.address = {
                    search: null,
                };
            },

            clearFioAndBirthday(person) {
                person.fio = {
                    surname: null,
                    name: null,
                    patronymic: null,
                    noPatronymic: false,
                    old: false,
                    oldSurname: null
                };
                person.birthday = null;
            },

            getDateDriverPassport(driver) {
                let dates = this.setDriverBirthday(driver);
                return dates ? dates.dateDriverPassport : this.dateDriversMinimal;
            },

            getDateFirstLicense(driver) {
                let dates = this.setDriverBirthday(driver);
                return dates ? dates.dateFirstLicense : this.dateDriversMinimal;
            },

            setPassportIssuedBy(person) {
                if (person.passport.seriesNumber) {
                    person.passport.issuedBy = 'МВД РФ';
                }
            },

            oldLicenseToggle(driver) {
                driver.license.oldSeriesNumber = '';
                if (!driver.license.old && driver.fio.old) {
                    driver.fio.old = false;
                    driver.fio.oldSurname = '';
                }
                this.drivers = this.drivers.map(item => item.n === driver.n ? driver : item);
            },

            oldSurnameToggle(driver) {
                driver.fio.oldSurname = '';
                if (driver.fio.old && !driver.license.old) {
                    driver.license.old = true;
                    driver.license.oldSeriesNumber = '';
                }
                this.drivers = this.drivers.map(item => item.n === driver.n ? driver : item);
            },

            isSamePerson(person1, person2) {
                if (!person1.birthday || !person2.birthday
                    || !person1.fio.surname || !person2.fio.surname
                    || !person1.fio.name || !person2.fio.name) return false;
                return person1.birthday === person2.birthday && _.isEqual(person1.fio, person2.fio);
            },

            setGender(person) {
                if (person.fio.patronymic) {
                    person.gender = person.fio.patronymic.endsWith('а') ? 'Женский' : 'Мужской';
                }
            },

            unlimitedDriversChange(val) {
                if (!val && this.drivers === 'unlimited') {
                    this.drivers = [];
                    this.addDriver();
                }
            },

            loadConfig(config) {
                this.getpolisPhone = config.getpolis_phone;
                this.dateToday = config.todayDate;
                this.dateTomorrow = config.tomorrowDate;
                this.dateStartMax = config.dateStartMax;
                this.dateFrom = config.offsetDate;
                this.dateDriversMinimal = config.driversMinimalDate;

                if (_.has(config, 'car.mark')) {
                    this.transport = Object.assign(this.transport, config.car);
                }
            },

            loadOrderData(data) {
                if (data.owner.address !== undefined) {
                    if (data.owner.address.search === undefined) {
                        data.owner.address.search = data.owner.address.region
                            + (data.owner.address.city ? ', ' + data.owner.address.city : '')
                            + (data.owner.address.street ? ', ' + data.owner.address.street : '')
                            + (data.owner.address.house ? ', ' + data.owner.address.house : '')
                            + (data.owner.address.flat ? ', кв ' + data.owner.address.flat : '');
                    }
                    if (data.owner.fio.noPatronymic === undefined) {
                        data.owner.fio.noPatronymic = false;
                    }
                }
                if (data.insurer !== undefined) {
                    if (data.insurer.address !== undefined && data.insurer.address.search === undefined) {
                        data.insurer.address.search = data.insurer.address.region
                            + (data.insurer.address.city ? ', ' + data.insurer.address.city : '')
                            + (data.insurer.address.street ? ', ' + data.insurer.address.street : '')
                            + (data.insurer.address.house ? ', ' + data.insurer.address.house : '')
                            + (data.insurer.address.flat ? ', кв ' + data.insurer.address.flat : '');
                    }
                    if (data.insurer.fio.noPatronymic === undefined) {
                        data.insurer.fio.noPatronymic = false;
                    }
                }
                if (data.insurer === undefined) data.insurer = {};
                if (data.insurer.address === undefined) data.insurer.address = {search: null};

                if (data.drivers === 'unlimited') {
                    this.unlimitedDrivers = true;
                    this.drivers = data.drivers;
                } else if (data.drivers) {
                    data.drivers.forEach((driver) => {
                        if (!driver.license.oldSeriesNumber) {
                            driver.license.oldSeriesNumber = '';
                            driver.license.old = false;
                        } else {
                            driver.license.old = true;
                        }

                        driver.address = {search: null};

                        if (driver.isInsurer || this.isSamePerson(driver, data.insurer)) {
                            driver.isInsurer = false;
                            driver.passport = data.insurer.passport ? data.insurer.passport : {};
                            driver.address = data.insurer.address ? data.insurer.address : {};
                        }

                        if (driver.isOwner || this.isSamePerson(driver, data.owner)) {
                            driver.isOwner = false;
                            driver.passport = data.owner.passport ? data.owner.passport : {};
                            driver.address = data.owner.address ? data.owner.address : {};
                        }

                        if (driver.fio.noPatronymic === undefined) {
                            driver.fio.noPatronymic = false;
                        }

                        this.drivers.push(driver);
                    });
                } else {
                    this.addDriver();
                }

                if (data.owner.fio.noPatronymic === undefined) {
                    data.owner.fio.noPatronymic = false;
                }

                if (data.step && !sessionStorage.step && sessionStorage.step != '0') {
                    this.step = data.step
                }

                if (data.dateStart) {
                    this.dateStart = data.dateStart
                }

                // if (data.useTargetPersonal) {
                //     this.useTargetPersonal = data.useTargetPersonal
                // }

                if (data.privacyPolicyApproved) {
                    this.privacyPolicyApproved = data.privacyPolicyApproved
                }

                this.alertText = data.alertText ? data.alertText : null;
                this.alertColor = data.alertColor ? data.alertColor : null;
                this.dateOldPolis = data.dateOldPolis ? data.dateOldPolis : null;
                this.osagoCompanyName = data.osagoCompanyName ? data.osagoCompanyName : null;

                if (this.transport.licensePlate) {
                    this.gosNumber = this.transport.licensePlate
                }

                this.owner = Object.assign(this.owner, data.owner);
                this.transport = Object.assign(this.transport, data.transport);
                // пока что обнуляем данные ДК
                this.transport.toDoc = this.toDocDefault;
                this.user = Object.assign(this.user, data.user);

                this.step4Requests()
            },

            prepareFormData() {
                if (!this.unlimitedDrivers && this.step == 2 && !this.ownerIsSet) {
                    this.owner = _.cloneDeep(this.drivers[0]);
                    this.insurer = _.cloneDeep(this.drivers[0]);
                }
                let drivers = this.step > 1 ? _.cloneDeep(this.drivers) : [];

                if (this.step == 3 || this.step == 4) {
                    this.ownerIsSet = true
                    this.insurer = _.cloneDeep(this.owner);
                    if (!this.unlimitedDrivers) {
                        drivers.forEach(driver => {
                            driver.isOwner = false
                            driver.isInsurer = false
                        })
                    }
                }
                this.preparedFormData = {
                    term: _.cloneDeep(this.term),
                    dateStart: _.cloneDeep(this.dateStart),
                    dateOldPolis: _.cloneDeep(this.dateOldPolis),
                    osagoCompanyName: this.osagoCompanyName,
                    usagePurpose: this.usagePurpose,
                    privacyPolicyApproved: this.privacyPolicyApproved,
                    prevPolicyNumber: this.prevPolicyNumber,
                    drivers: this.unlimitedDrivers ? 'unlimited' : drivers,
                    owner: this.owner,
                    insurer: this.insurer,
                    transport: _.cloneDeep(this.transport),
                    user: _.cloneDeep(this.user),
                    isEgarant: _.cloneDeep(this.isEgarant),
                    step: _.cloneDeep(this.step),
                    widgetId: this.widgetId,
                    alertText: this.alertText,
                    alertColor: this.alertColor
                };
                this.savePreparedData();
            },

            savePreparedData() {
                const parsed = JSON.stringify(this.preparedFormData)
                sessionStorage.setItem('preparedFormDataStorage', parsed)
            },

            setStep(newStep) {
                this.step = newStep
                sessionStorage.step = newStep
                this.goToTop()
                this.updatePercents()
                if (this.step == 4) {
                    this.reachGoal('start_fill_scard_srts')
                }
            },

            goToTop() {
                this.$nextTick().then(() => {
                    if (this.step < 4) {
                        this.$vuetify.goTo('.header-part', {duration: 500});
                    }
                })
            },

            setUuid(newUuid) {
                this.uuid = newUuid
                sessionStorage.uuid = newUuid
            },

            changePreloading() {
                this.preloading = !this.preloading
            },

            next() {
                if (this.step === 0) {
                    this.setStep(1)
                } else {
                    if (this.$refs.form.validate()) {
                        this.reachGoal('step3_click');
                        if (this.step === 1 && !this.uuid) {
                            this.save()
                        } else if (this.step === 1 && this.uuid) {
                            this.update()
                        }
                        if (this.step === 2) {
                            this.update()
                        }
                        if (this.step === 3) {
                            this.update()
                        }
                        if (this.step === 4) {
                            this.submit()
                        }
                    } else {
                        this.$nextTick(function () {
                            PNotify.error('Проверьте правильность выделенных полей.');
                            this.goToFirstError();
                        });
                    }
                }
                if (parseInt(sessionStorage.maxStep) < this.step) {
                    sessionStorage.maxStep = this.step
                }
                this.updatePercents()
            },

            back() {
                this.setStep(this.step-1)
                if (this.step == 0) {
                    this.clearProgress()
                }
                this.updatePercents()
            },

            clearProgress() {
                sessionStorage.removeItem('preparedFormDataStorage');
                sessionStorage.removeItem('stepFlags');
                sessionStorage.uuid = null;
                sessionStorage.step = 0;
                sessionStorage.addedDriversToStep3 = false;
                sessionStorage.maxStep = 0;
                if (this.isWidget) {
                    window.history.pushState(null, null, '/widget/' + this.widgetUuid);
                    window.location.replace('/widget/' + this.widgetUuid);
                } else {
                    window.history.pushState(null, null, '/calc/');
                    window.location.replace('/calc/');
                }
            },

            toStep(n) {
                if (this.step > n) {
                    this.setStep(n)
                    this.loadedFromStorage = false
                    this.checkSessionStorage()
                }
                this.updatePercents()
            },

            updateAutoSave() {
                if (this.step > 1 && this.step < 5) {
                    if (!this.autoSaveInterval) {
                        this.autoSaveOn(5000);
                    }
                } else {
                    this.autoSaveOff();
                }
            },

            save() {
                this.wait = true;
                this.prepareFormData();
                axios.post('/osago/calc/' + (this.uuid ? this.uuid + '/save' : 'save'), this.preparedFormData)
                    .then(response => {
                        if (response.data.uuid) {
                            this.setUuid(response.data.uuid);
                            window.history.pushState(null, null, '/osago/calc/' + this.uuid +
                                (this.isWidget ? '?isWidget=1' : ''));
                            if (!response.data.userChecked) {
                                sessionStorage.step = this.step+1
                                window.location.replace('/osago/calc/' + this.uuid + '/continue' +
                                    (this.isWidget ? '?isWidget=1' : '')
                                );
                            } else {
                                this.startPreloading();
                                this.setStep(this.step+1);
                            }

                            this.updateAutoSave();
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.wait = false;
                    });
            },

            autoUpdate(formData) {
                axios.post(`/osago/calc/${this.uuid}/update`, formData)
                    .then(response => {
                        if (response.data.uuid) {
                            this.savePreparedData()
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            update() {
                this.wait = true
                this.prepareFormData()
                axios.post(`/osago/calc/${this.uuid}/update`, this.preparedFormData)
                    .then(response => {
                        if (response.data.uuid) {
                            if (this.step === 2) {
                                this.reachGoal('filled_block_drivers')
                            }
                            if (this.step === 3) {
                                this.reachGoal('filled_block_insurer')
                            }
                            this.setUuid(response.data.uuid)
                            this.startPreloading()
                            this.setStep(this.step+1)
                            this.updateAutoSave()
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.wait = false;
                        $('.preview-window').css('height', '0px');
                    });
            },

            submit() {
                this.wait = true;
                this.prepareFormData();
                axios.post('/osago/calc/' + (this.uuid ? this.uuid + '/updateb2c' : 'new'), this.preparedFormData)
                .then(response => {
                    if (response.data.uuid) {
                        axios.post(`/osago/calc/${this.uuid}/cancelupdateactive`);
                        this.uuid = response.data.uuid;
                        let queryParams = '';
                        if (this.needRequestInsurance || this.isWidget) {
                            let arr = [];
                            if (this.needRequestInsurance) {
                                arr.push('autoRequest=true');
                            }
                            if (this.isWidget) {
                                arr.push('isWidget=1');
                            }
                            queryParams = '?' + arr.join('&');
                        }
                        window.location.replace('/osago/new/' + this.uuid + queryParams);
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.preloading = false;
                    throw error;
                })
                .finally(() => {
                    this.wait = false;
                })
            },

            clear() {
                this.$refs.form.reset()
            },

            delay(ms) {
                return new Promise((resolve, reject) => {
                    this.timeout = setTimeout(resolve, ms)
                })
            },

            updatePercents: function() {
                switch (this.step) {
                    case 1:
                        this.progressPercent = 55
                        break;
                    case 2:
                        this.progressPercent = 65
                        break;
                    case 3:
                        this.progressPercent = 93
                        break;
                    case 4:
                        this.progressPercent = 93
                        break;
                    default:
                        this.progressPercent = 0
                        break;
                }
            },

            loadRsaPolicyData() {
                this.prevPolicyLoading = true;
                if (this.transport.vin) {
                    this.rsaDataRequest(this.transport.vin, 'vin');
                } else if (this.transport.bodyNumber) {
                    this.rsaDataRequest(this.transport.bodyNumber, 'body');
                }
                this.savePreparedData()
            },

            rsaDataRequest(number, type) {
                this.rsaInfoLoading = true
                let param = '';
                switch (type) {
                    case 'vin':
                        param = 'vin=' + number;
                        break;
                    case 'body':
                        param = 'bodyNumber=' + number;
                        break;
                    default:
                        PNotify.error('Невозможно получить данные предыдущего полиса.');
                        that.savePreparedData()
                        return;
                }
                const that = this;
                axios.get('/info/rsa?' + param)
                    .then(result => {
                        if (result.data.response && result.data.status === 'ok') {
                            const info = result.data.response;
                            that.prevPolicyNumber = info.policySerial;
                            if (that.prevPolicyNumber) {
                                that.prevPolicyNumber += ' ' + info.policyNumber;
                            } else {
                                that.prevPolicyNumber += ' ' + info.policyNumber;
                            }
                            that.osagoCompanyName = info.companyName
                            that.dateOldPolis = moment(info.endDate).format('YYYY-MM-DD')

                            that.savePreparedData()

                            that.prevPolicyLoading = false;
                        } else {
                            if (type === 'vin') {
                                if (that.transport.bodyNumber) {
                                    this.rsaDataRequest(that.transport.bodyNumber, 'body');
                                    return;
                                }
                            } else if (type === 'body') {
                                if (that.transport.vin) {
                                    this.rsaDataRequest(that.transport.vin, 'vin');
                                    return;
                                }
                            }
                            that.savePreparedData()
                            that.prevPolicyLoading = false;
                        }
                        that.savePreparedData()
                    })
                    .catch(error => {
                        that.prevPolicyLoading = false;
                        that.savePreparedData()
                        console.log(error);
                    })
                    .finally(() => {
                        this.rsaInfoLoading = false
                    })
            },

            getFirstLicenseYears(minDate, maxDate) {
                const minYear = minDate ? +minDate.split('-')[0] : 1920;
                const maxYear = maxDate ? +maxDate.split('-')[0] : 2099;
                let years = [];
                for (let i = maxYear; i >= minYear; i--) {
                    years[years.length] = i;
                }
                return years;
            }
        }
    }
</script>

<style scoped>

</style>
<style>

</style>



// WEBPACK FOOTER //
// resources/js/components/OsagoPreCalcFormWithSteps.vue